<div class="form-section">
  <!-- Sin `title` no se pinta rótulo: la tarjeta queda como contenedor de campos a secas. Es lo
       que necesita un modal de una sola sección, donde la cabecera del propio modal ya dice de
       qué va y un segundo rótulo en versalitas justo debajo solo añade ruido. -->
  <h3 class="section-title" *ngIf="title">
    <div class="title-icon-wrapper" *ngIf="icon">
      <i [class]="icon"></i>
    </div>
    {{ title | translate: titleParams }}
  </h3>
  <ng-content></ng-content>
</div>
